import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Spinner } from 'reactstrap';
import Alert from '@/shared/components/Alert';
import { processPendingImports } from '../qaToolsApi';

const UNAVAILABLE = 'QA Tools are not available on this environment.';

/**
 * Why: the QA box has no import cron, so a file uploaded through Import Configurations waits
 *      until someone presses this.
 * Scope: every waiting upload, processed the way the cron does (the API answers 404 outside QA
 *        and local); each file is listed with its counts and links to its Import History page.
 * SRP: triggers the run and shows the outcome; processing is the API's job.
 */
const ProcessPendingImports = () => {
  const [processed, setProcessed] = useState(undefined);
  const [error, setError] = useState(null);
  const [isBusy, setBusy] = useState(false);

  const onProcess = async () => {
    setBusy(true);
    setError(null);
    setProcessed(undefined);
    const result = await processPendingImports();
    setBusy(false);
    if (result.available === false) {
      setError(UNAVAILABLE);
      return;
    }
    if (result.errors) {
      setError(result.errors);
      return;
    }
    setProcessed(result.processed);
  };

  const nothingWasWaiting = processed?.length === 0;
  const someFilesRan = processed?.length > 0;

  return (
    <>
      <div className='card__title'>
        <h5 className='subhead'>
          Upload a file under Import Configurations, then press this to run it now instead of waiting for the import cron.
        </h5>
      </div>
      <Button color='primary' size='sm' className='mb-3' disabled={isBusy} onClick={onProcess}>
        {isBusy ? <><Spinner size='sm' className='mr-2' />Working...</> : 'Process uploaded files now'}
      </Button>

      {error && <Alert color='danger' className='alert--bordered' icon><p>{error}</p></Alert>}
      {nothingWasWaiting && <p>No uploaded files were waiting.</p>}
      {someFilesRan && (
        <table className='table table--bordered mb-0'>
          <thead><tr><th>File</th><th>Result</th></tr></thead>
          <tbody>
            {processed.map(file => (
              <tr key={file.id}>
                <td><Link to={`/import/view/${file.id}`}>{file.name}</Link></td>
                <td>{`${file.added} added, ${file.updated} updated, ${file.failed} failed`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ProcessPendingImports;
